import config from 'config'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withStateHandlers, withHandlers, lifecycle } from 'recompose'
import { push } from 'connected-react-router'
import * as UserSelectors from 'modules/user/selectors'
import { updateUserProperties } from 'modules/user/actions'
import { updateOrgProperties } from 'modules/org/actions'
import * as OrgSelectors from 'modules/org/selectors'
import { MeetingsStepWithPrime } from './component'

import { track, page } from 'utils/trackingUtils'

const mapStateToProps = state => ({
  color: OrgSelectors.getColor(state),
  isRepInvitedFlow: UserSelectors.isRepInvitedFlow(state),
  isSSOProvisionedFlow: UserSelectors.isSSOProvisionedFlow(state),
  userId: UserSelectors.getUserId(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    updateUserProperties,
    updateOrgProperties,
    push
  }, dispatch),
})

const finishSetup = props => {
  track('Onboarding Completed', {
    context: props.isCalendarSeat
      ? 'calendaring-seat-onboarding'
      : props.isRepInvitedFlow
      ? 'rep-onboarding'
      : 'sales-onboarding',
    isSSO: props.isSSOProvisionedFlow,
    shownExtension: false
  })

  if (props.isSSOProvisionedFlow) {
    props.actions.updateUserProperties({
      properties: {
        IS_JIT_PROVISIONED_USER: false,
      },
    })
  }
  if (props.isRepInvitedFlow) {
      window.location.replace(`${config.CUSTOMER_WEB_URL}/home`)
  }
  else {
    props.actions.updateOrgProperties({ properties: { signUpDone: true, onboardedDriftForSales: true }, redirect: true })
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      page('Onboarding Meetings Setup', {
        context: this.props.isCalendarSeat
          ? 'calendaring-seat-onboarding'
          : this.props.isRepInvitedFlow
          ? 'rep-onboarding'
          : 'sales-onboarding',
        experiment: 'prime-and-two-skip'
      })
    }
  }),
  withStateHandlers(() => ({
    connectError: null,
  }),
  {
    setConnectError: () => (connectError) => ({ connectError })
  }),
  withHandlers({
    onSkipClick: props => (e) => {
      if (window.chrome) {
        track('Onboarding Meetings Setup Completed', {
          context: props.isCalendarSeat
          ? 'calendaring-seat-onboarding'
          : props.isRepInvitedFlow
          ? 'rep-onboarding'
          : 'sales-onboarding',
          method: 'skipped'
        })
        if (props.isCalendarSeat) {
          props.actions.push('/setup/calendaring/hooray')
        } else {
          props.actions.push('/setup/extension')
        }
      } else {
        e.preventDefault()
        finishSetup(props)
      }
    }
  })
)(MeetingsStepWithPrime)

